
import BaseSvg from "@/components/base/BaseSvg.vue";
import { EEE_dd_MMM_YYYY, HHmm, today } from "@/helpers/dateHelper";
import { DirectionEnum, ModeOfTravelEnum } from "@/models/enums";
import { BookingSummarySection } from "@/models/www/store/BookingSummary";
import { computed, defineComponent, PropType } from "vue";
import { useRoute } from "vue-router";

export default defineComponent({
	components: {
		BaseSvg,
	},
	props: {
		direction: {
			type: Number as PropType<DirectionEnum>,
			required: true,
		},
		bookingSection: {
			type: Object as PropType<BookingSummarySection>,
			default: () => {
				return {} as BookingSummarySection;
			},
		},
		currency: String,
		displayTime: Boolean,
	},
	setup() {
		const route = useRoute();
		
		return { DirectionEnum, EEE_dd_MMM_YYYY, HHmm, ModeOfTravelEnum, today };
	},
});
